/* MB — Footer mobile : tiroirs Contact + Besoin d'aide (<=700px). */
(function(){
  function initFooter(){
    var root=document.querySelector('.footer--root');
    if(!root)return;
    if(window.innerWidth>700){root.classList.remove('mb-acc-ready');return;}
    if(root.getAttribute('data-mb-acc')==='1'){root.classList.add('mb-acc-ready');return;}
    root.setAttribute('data-mb-acc','1');
    root.classList.add('mb-acc-ready');
    var about=root.querySelector('.footer--block[data-block-type="about"]');
    if(about)about.classList.add('mb-open');
    var heads=root.querySelectorAll('.footer--block[data-block-type="about"]>.footer--block--container>.footer--block--heading,.footer--block[data-block-type="menu"]>.footer--block--container>.footer--block--heading');
    Array.prototype.forEach.call(heads,function(h){
      var block=h.closest('.footer--block');
      h.setAttribute('role','button');
      h.setAttribute('tabindex','0');
      h.setAttribute('aria-expanded',block.classList.contains('mb-open')?'true':'false');
      function tog(){var o=block.classList.toggle('mb-open');h.setAttribute('aria-expanded',o?'true':'false');}
      h.addEventListener('click',tog);
      h.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();tog();}});
    });
  }
  if(document.readyState!=='loading')initFooter();else document.addEventListener('DOMContentLoaded',initFooter);
  window.addEventListener('resize',initFooter);
})();
